/**
 * 通用侧边栏状态管理
 * 支持画廊分类导航和文章TOC两种场景
 */
export interface SidebarItem {
  id: string
  text: string
  level?: number
}

export const useSidebar = (key: string = 'default') => {
  // 使用 key 区分不同页面的侧边栏状态
  const isOpen = useState<boolean>(`sidebar-open-${key}`, () => false)
  const items = useState<SidebarItem[]>(`sidebar-items-${key}`, () => [])
  const activeId = useState<string>(`sidebar-active-${key}`, () => '')

  // 监听路由变化，自动关闭侧边栏
  const route = useRoute()
  watch(() => route.fullPath, () => {
    if (isOpen.value) {
      isOpen.value = false
    }
  })

  const setItems = (newItems: SidebarItem[]) => {
    items.value = newItems
  }

  const setActiveId = (id: string) => {
    activeId.value = id
  }

  const open = () => {
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
  }

  const toggle = () => {
    isOpen.value = !isOpen.value
  }

  return {
    isOpen,
    items,
    activeId,
    setItems,
    setActiveId,
    open,
    close,
    toggle
  }
}
